/**
 * Standard park keys for park-scoped bucket storage (must/nice by park).
 * Use short keys in formData to keep payload small and deterministic.
 */

/** Canonical storage keys for the four theme parks (used in mustXByPark / niceXByPark). */
export const PARK_KEYS = ["mk", "epcot", "hs", "ak"];

/** Map display names (as in parkVisitPlans.parks) to storage keys. */
export const PARK_DISPLAY_NAME_TO_KEY = {
  "Magic Kingdom": "mk",
  "EPCOT": "epcot",
  "Hollywood Studios": "hs",
  "Animal Kingdom": "ak",
};

/** Map storage key to display name (for labels). */
export const PARK_KEY_TO_DISPLAY_NAME = {
  mk: "Magic Kingdom",
  epcot: "EPCOT",
  hs: "Hollywood Studios",
  ak: "Animal Kingdom",
};

export function getParkKey(displayName) {
  if (!displayName || typeof displayName !== "string") return null;
  return PARK_DISPLAY_NAME_TO_KEY[displayName] ?? null;
}

export function getParkDisplayName(key) {
  return PARK_KEY_TO_DISPLAY_NAME[key] ?? key;
}

export function getEmptyRidesBuckets() {
  return PARK_KEYS.reduce((acc, k) => ({ ...acc, [k]: [] }), {});
}

export function getEmptyShowsBuckets() {
  return PARK_KEYS.reduce((acc, k) => ({ ...acc, [k]: [] }), {});
}

export function getEmptyRestaurantsBuckets() {
  return PARK_KEYS.reduce((acc, k) => ({ ...acc, [k]: [] }), {});
}

export function normalizeBucket(bucket) {
  if (!bucket || typeof bucket !== "object") return getEmptyRidesBuckets();
  const out = { ...bucket };
  for (const k of PARK_KEYS) {
    if (!Array.isArray(out[k])) out[k] = [];
  }
  return out;
}
